export const LEAD_PLACES_EXHAUSTED = 'LEAD_PLACES_EXHAUSTED';

const leadPlacesExhausted = lead => (
  (dispatch) => {
    dispatch({
      type: LEAD_PLACES_EXHAUSTED,
      lead,
    });
  }
);

export default leadPlacesExhausted;
